import PropTypes from "prop-types";

/**
 * A bold label with an optional required indicator.
 *
 * @param {object} props
 * @param {string} props.text - The label text to display.
 * @param {string} [props.htmlFor] - Associates the label with an input via its `id`.
 * @param {boolean} [props.isRequired=false] - When true, renders a red asterisk after the text.
 */
const Label = ({ text, htmlFor, isRequired }) => {
  return (
    <label htmlFor={htmlFor} className="font-bold">
      {text}
      {isRequired && (
        <span aria-hidden="true" className="text-red-500 ml-1">
          *
        </span>
      )}
    </label>
  );
};

Label.propTypes = {
  text: PropTypes.string.isRequired,
  htmlFor: PropTypes.string,
  isRequired: PropTypes.bool,
};

export default Label;
